import Layout from "../components/Layout/Layout";
import Casebanner from "../components/Casebanner/Casebanner";
import CasebannerLoading from "../components/Casebanner/CasebannerLoading";
import BodyLoading from "../components/BodyLoading/BodyLoading";
import Author from "../components/Author/Author";
import Login from "../components/Login/Login";
import NotFound from "./NotFound";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { usePageMeta } from "../hooks/usePageMeta";

const PROTECTED_IDS = ["7", "9", "10", "11"];

function resolveUrl(backend, path) {
  if (!path) return null;
  return path.startsWith("http") ? path : `${backend.replace(/\/$/, "")}${path}`;
}

function CaseDetail() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [error, setError] = useState(false);
  const { id } = useParams();
  const apiPath = process.env.REACT_APP_PAGES_API_PATH;
  const apiKey = process.env.REACT_APP_API_KEY;
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const casePassword = process.env.REACT_APP_CASE_PASSWORD;

  const isProtected = PROTECTED_IDS.includes(id);

  useEffect(() => {
    setLoading(true);
    setData(null);

    const getData = async () => {
      try {
        const response = await axios.get(apiPath + `${id}/`, {
          headers: { Authorization: `Api-Key ${apiKey}` },
        });
        setData(response.data);
      } catch (err) {
        if (err.response?.status === 404) {
          setNotFound(true);
        } else {
          setError("Failed to fetch data.");
        }
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [id, apiPath, apiKey]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === casePassword) {
      setIsAuthorized(true);
    } else {
      setError(true);
    }
  };

  const showContent = !isProtected || isAuthorized;

  const metaTitle = data?.meta?.seo_title || (data?.title ? `${data.title} | Vasapon Portfolio` : null);
  const metaDescription = data?.meta?.search_description || data?.intro || null;
  const authorName = data?.author_name || null;
  const ogImage =
    resolveUrl(backend, data?.thumbnail?.url) ||
    resolveUrl(backend, data?.cover?.meta?.download_url);
  const pageUrl = window.location.href;

  usePageMeta({
    title: metaTitle,
    description: metaDescription,
    ogType: "article",
    ogImage: ogImage,
    ogUrl: pageUrl,
    authorName: authorName,
  });

  if (notFound) return <NotFound />;

  return (
    <Layout>

      {isProtected && !isAuthorized ? (
        <Login
          onSubmit={handleSubmit}
          password={passwordInput}
          setPassword={setPasswordInput}
          error={error}
        />
      ) : loading ? (
        <CasebannerLoading />
      ) : (
        <Casebanner
          image={data?.cover ? data.cover.meta.download_url : ""}
          heading={data?.title}
          intro={data?.intro}
          role={data?.group}
          tools={data?.tools}
        />
      )}

      {showContent && (
        loading ? (
          <BodyLoading />
        ) : (
          <section id="case-body">
            {data?.body ? (
              <div
                className="case-body-container"
                dangerouslySetInnerHTML={{
                  __html: data.body.replace(
                    /src="(\/[^"]+)"/g,
                    `src="${backend.replace(/\/$/, "")}$1"`,
                  ),
                }}
              />
            ) : (
              <div className="no-data">
                <p className="body-large" style={{ fontWeight: "bold" }}>
                  No Data Found
                </p>
              </div>
            )}
          </section>
        )
      )}

      {showContent && !loading && data?.author?.id && (
        <Author author_id={data.author.id} />
      )}
    </Layout>
  );
}

export default CaseDetail;
